import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

import { StatusCount } from "@app/project/store/projects.state";
import { TableFilterProperties } from "@app/shared/model/action.model";
import { IFilters } from "@app/shared/services/filter.service";
import { PermissionsHelperService } from "@app/shared/services/permissions-helper.service";
import { SearchPayload } from "../clare-search/clare-search.component";

@Component({
    selector: "clare-list-header",
    templateUrl: "./clare-list-header.component.html",
    styleUrls: ["./clare-list-header.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClareListHeaderComponent {
    @Input() title: string;
    @Input() shouldHideSearch = false;
    @Input() shouldHideRefresh = false;
    @Input() addButtonText: string;
    @Input() useAlternateAdd = false;
    @Input() statusCounts: StatusCount[];
    @Input() activeCounts: StatusCount[];
    @Input() shouldEnableAddButton = true;
    @Input() isLoading = true;
    @Input() shouldDisplayItemCount: boolean;
    @Input() dataSourceLength: number;
    @Input() shouldPlaceSearchLeft = false;
    @Input() initialQueryString = "";
    @Input() initialStatusFilters: { [key: string]: string[] } = {};

    @Output() changeFilterHandler = new EventEmitter<Partial<TableFilterProperties>>();
    @Output() refreshDataHandler = new EventEmitter<void>();
    @Output() addDataHandler = new EventEmitter<void>();
    permissionTypes = ["RemoveZWave", "AddDevices"];
    @Input() isFilterHidden = false;

    constructor(private readonly permissionsHelperService: PermissionsHelperService) {
        this.permissionsHelperService.checkMultiplePermissions(this.permissionTypes, ["view", "edit"]);
    }

    /**
     * @description Emits the selected filters to the parent component
     * @param {IFilters} selectedFilters the currently selected filters
     */
    public onFilterChange(selectedFilters: IFilters) {
        this.changeFilterHandler.emit({ selectedFilters });
    }

    /**
     * @description Emits the prepared search term to the parent component
     * @param {SearchPayload} searchTerm the term to search in object form
     */
    public onDataSearch(searchTerm: SearchPayload) {
        this.changeFilterHandler.emit(searchTerm);
    }

    /**
     * @description Emits an event when the add button is pressed
     */
    public onAdd() {
        this.addDataHandler.emit();
    }

    /**
     * @description Emits an event when the refresh button is pressed
     */
    public onDataRefresh() {
        this.refreshDataHandler.emit();
    }

    /**
     * @description creates a dynamic permission string based on the actionItem input
     * @param {string} actionItem
     * @returns string
     */
    public checkPermissions(actionItem: string) {
        return actionItem === "Devices";
    }
}
